var DataSpecType;
(function (DataSpecType) {
    DataSpecType["polygon"] = "polygon";
    DataSpecType["points"] = "points";
    DataSpecType["lines"] = "lines";
})(DataSpecType || (DataSpecType = {}));
export { DataSpecType, };
